export const environment = {
    production: false,
    API_KEY: 'f47aa4f3-3b41-42e5-b9e7-e2c1f6a73bdf',
    CK: 's4f3TC9RoGp#OQ8KjkeIfNVDvs36mBlH',
    SERVICES_URL: 'https://dev.safeconfidence.com.mx/api/web',
    //SERVICES_URL: 'https://qa.safeconfidence.com.mx/api/web',
    //SERVICES_URL: '/api',
};
